module.exports = "<accordian-basic data-items=\"article.articleSections\"></accordian-basic>\r\n";